import React, { useEffect } from 'react';
import './Toast.css';
import { FaCheckCircle, FaTimesCircle, FaInfoCircle } from 'react-icons/fa';

const iconStyle = { color: 'rgba(255, 255, 255, 0.92)', fontSize: '1.65rem' };

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return <FaCheckCircle style={iconStyle} />;
    case 'error':
      return <FaTimesCircle style={iconStyle} />;
    case 'info':
    default:
      return <FaInfoCircle style={iconStyle} />;
  }
};

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000); // O toast desaparece após 5 segundos

    return () => {
      clearTimeout(timer);
    };
  }, [onClose]);

  return (
    <div className={`toast toast-${type}`}>
      {getIcon(type)}
      <p style={{ margin: 0 }}>{message}</p>
      <button onClick={onClose} className="toast-close-btn">&times;</button>
    </div>
  );
};

export default Toast;